const departmentMapper = (data) => {
    let resultArray = [];

    function getChild(data, item, offset = 0) {
        const firstLevel = data.filter(child => (!item && !child.parent_id) || (item && child.parent_id === item.id));

        firstLevel.forEach(parent => {
            resultArray.push({
                ...parent,
                name: '    '.repeat(offset) + parent.name,
            });

            if (data.some(dataItem => dataItem.parent_id === parent.id)) {
                getChild(data, parent, offset + 1);
            }
        });
    }
    getChild(data);

    data.forEach(item => {
        if (!resultArray.find(child => child.id === item.id)) {
            resultArray.push(item);
        }
    });

    return resultArray;
}

export default departmentMapper;
